import { useState } from "react";
import { Modal } from "./modal";
import { cn } from "../../lib/utils";

interface PromptModalProps {
  title: string;
  label?: string;
  initial?: string;
  placeholder?: string;
  submitLabel: string;
  maxLength?: number;
  onSubmit: (value: string) => void;
  onClose: () => void;
}

export function PromptModal({ title, label, initial = "", placeholder, submitLabel, maxLength = 40, onSubmit, onClose }: PromptModalProps) {
  const [value, setValue] = useState(initial);
  const [touched, setTouched] = useState(false);
  const valid = value.trim().length > 0;

  const submit = () => {
    if (!valid) { setTouched(true); return; }
    onSubmit(value.trim());
  };

  return (
    <Modal
      title={title}
      onClose={onClose}
      width="max-w-sm"
      footer={
        <>
          <button onClick={onClose} className="rounded-lg border border-line px-4 py-2 text-sm font-semibold text-ink hover:bg-soft">
            Cancel
          </button>
          <button
            onClick={submit}
            disabled={!valid}
            className={cn("rounded-lg px-4 py-2 text-sm font-semibold text-white",
              valid ? "bg-brand hover:bg-brand-hover" : "cursor-not-allowed bg-line text-ink-3")}
          >
            {submitLabel}
          </button>
        </>
      }
    >
      <form onSubmit={(e) => { e.preventDefault(); submit(); }}>
        <label className="block">
          {label && (
            <span className="mb-1 block font-mono text-[10px] font-semibold uppercase tracking-wider text-ink-3">{label}</span>
          )}
          <input
            autoFocus
            value={value}
            maxLength={maxLength}
            onChange={(e) => setValue(e.target.value)}
            onBlur={() => setTouched(true)}
            placeholder={placeholder}
            className={cn(
              "w-full rounded-lg border px-3 py-2.5 text-sm text-ink focus:outline-none focus:ring-2 focus:ring-brand/30",
              touched && !valid ? "border-danger/50" : "border-line focus:border-brand",
            )}
          />
        </label>
        {touched && !valid && <p className="mt-1 text-xs text-danger">Name is required.</p>}
        <button type="submit" hidden />
      </form>
    </Modal>
  );
}
